
import { z } from 'zod';

export const paymentSchema = z.object({
  accountHolderName: z.string().min(1, "Account holder name is required").optional(),
  accountNumber: z.string().optional(),
  routingNumber: z.string().optional(),
  bankName: z.string().optional(),
  paypalEmail: z.string().email("Please enter a valid email").optional(),
  paypalUsername: z.string().optional(),
  preferredMethod: z.enum(["bank", "paypal"]),
});

export type PaymentFormValues = z.infer<typeof paymentSchema>;
